(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    class PriceFacetComponent extends HTMLElement {
    constructor() {
      super();
      this.minInput = this.querySelector('[ref="minInput"]');
      this.maxInput = this.querySelector('[ref="maxInput"]');
      this.minSlider = this.querySelector('[ref="minSlider"]');
      this.maxSlider = this.querySelector('[ref="maxSlider"]');
      this.rangeMin = parseFloat(this.dataset.rangeMin) || 0;
      this.rangeMax = parseFloat(this.dataset.rangeMax) || 100;
      
      this.init();
    }
    
    init() {
      if (this.minSlider && this.maxSlider) {
        this.updateSliderBackground();
        this.minSlider.addEventListener('input', this.handleSliderChange.bind(this));
        this.maxSlider.addEventListener('input', this.handleSliderChange.bind(this));
      }
      
      if (this.minInput) {
        this.minInput.addEventListener('input', this.handleInputChange.bind(this, 'min'));
        this.minInput.addEventListener('blur', this.validateInput.bind(this, 'min'));
      }
      
      if (this.maxInput) {
        this.maxInput.addEventListener('input', this.handleInputChange.bind(this, 'max'));
        this.maxInput.addEventListener('blur', this.validateInput.bind(this, 'max'));
      }
    }
    
    updateSliderBackground() {
      const min = parseFloat(this.minSlider.value);
      const max = parseFloat(this.maxSlider.value);
      const percentMin = ((min - this.rangeMin) / (this.rangeMax - this.rangeMin)) * 100;
      const percentMax = ((max - this.rangeMin) / (this.rangeMax - this.rangeMin)) * 100;
      
      const track = this.querySelector('.price-facet__slider-track');
      if (track) {
        track.style.background = `linear-gradient(to right, 
          var(--facets-border-color, #e5e5e5) 0%, 
          var(--facets-border-color, #e5e5e5) ${percentMin}%, 
          var( #0F2E53) ${percentMin}%, 
          var( #0F2E53) ${percentMax}%, 
          var(--facets-border-color, #e5e5e5) ${percentMax}%, 
          var(--facets-border-color, #e5e5e5) 100%)`;
      }
    }
    
    handleSliderChange() {
      let minVal = parseFloat(this.minSlider.value);
      let maxVal = parseFloat(this.maxSlider.value);
      
      if (minVal > maxVal) {
        [minVal, maxVal] = [maxVal, minVal];
        this.minSlider.value = minVal;
        this.maxSlider.value = maxVal;
      }
      
      this.minInput.value = Math.floor(minVal);
      this.maxInput.value = Math.floor(maxVal);
      
      this.updateSliderBackground();
      this.dispatchChangeEvent();
    }
    
    handleInputChange(type, event) {
      let value = parseFloat(event.target.value);
      
      if (isNaN(value)) {
        value = type === 'min' ? this.rangeMin : this.rangeMax;
      }
      
      if (type === 'min') {
        value = Math.min(value, this.rangeMax);
        value = Math.min(value, parseFloat(this.maxInput.value) || this.rangeMax);
        this.minSlider.value = value;
        this.minInput.value = Math.floor(value);
      } else {
        value = Math.max(value, this.rangeMin);
        value = Math.max(value, parseFloat(this.minInput.value) || this.rangeMin);
        this.maxSlider.value = value;
        this.maxInput.value = Math.floor(value);
      }
      
      this.updateSliderBackground();
      this.dispatchChangeEvent();
    }
    
    validateInput(type) {
      let value = parseFloat(this.querySelector(`[ref="${type}Input"]`).value);
      const otherValue = parseFloat(this.querySelector(`[ref="${type === 'min' ? 'max' : 'min'}Input"]`).value);
      
      if (isNaN(value)) {
        value = type === 'min' ? this.rangeMin : this.rangeMax;
      }
      
      if (type === 'min') {
        if (value < this.rangeMin) value = this.rangeMin;
        if (!isNaN(otherValue) && value > otherValue) value = otherValue;
        this.minSlider.value = value;
        this.minInput.value = Math.floor(value);
      } else {
        if (value > this.rangeMax) value = this.rangeMax;
        if (!isNaN(otherValue) && value < otherValue) value = otherValue;
        this.maxSlider.value = value;
        this.maxInput.value = Math.floor(value);
      }
      
      this.updateSliderBackground();
      this.dispatchChangeEvent();
    }
    
    dispatchChangeEvent() {
      const minValue = this.minInput.value;
      const maxValue = this.maxInput.value;
      
      const event = new CustomEvent('priceChange', {
        detail: { min: minValue, max: maxValue },
        bubbles: true
      });
      
      this.dispatchEvent(event);

      const changeEvent = new Event('change', { bubbles: true });
      this.dispatchEvent(changeEvent);
    }
  }
  
  customElements.define('price-facet-component', PriceFacetComponent);
  } catch(e) { console.error(e); }
})();

})();
